import moment from 'moment';
import { PRICE_LOGIC } from './constants';
import { ToastTypes, useMessage } from '../base/context/MessageProvider';
import { ProductsApiService } from '../service/website/productsApiService';
export const sidebarMenuHeight = length => {
  const hLength = 7 * length;
  const data = hLength.toString();
  return `h-${data}`;
};

export const sellerSidebarArray = [
  {
    name: 'Dashboard',
    icon: 'RiHome2Fill',
    link: '/seller/dashboard',
    items: [],
    opened: false,
    active: false,
    tabLink: '/seller/dashboard',
  },
  {
    name: 'Orders',
    icon: 'IoBag',
    link: '/seller/orders',
    items: [],
    opened: false,
    active: false,
    tabLink: '/seller/orders',
  },

  {
    name: 'Store Apis',
    icon: 'IoCart',
    link: '/seller/marketplaceApis',
    items: [],
    opened: false,
    active: false,
    tabLink: '/seller/marketplaceApis',
  },
  {
    name: 'Product Subscriptions',
    icon: 'FaCubes',
    link: '/seller/productSubscription',
    items: [],
    opened: false,
    active: false,
    tabLink: '/seller/productSubscription',
  },
  {
    name: 'IM Cash',
    icon: 'BsWalletFill',
    link: '/seller/wallet',
    items: [],
    opened: false,
    active: false,
    tabLink: '/seller/wallet',
  },
  {
    name: 'Reports',
    icon: 'FaFileAlt',
    link: '',
    items: [
      {
        name: 'Invoice',
        link: '/seller/reports/invoice',
      },
    ],
    opened: false,
    active: false,
    tabLink: '/seller/reports/invoice',
  },
  {
    name: 'Marketplace Settings',
    icon: 'IoMdSettings',
    link: '/seller/settings',
    items: [],
    opened: false,
    active: false,
    tabLink: '/seller/settings',
  },
];

export const adminSidebarArray = [
  {
    name: 'Dashboard',
    icon: 'FaTachometerAlt',
    link: '/admin/dashboard',
    items: [],
    opened: false,
    active: false,
    tabLink: '/admin/dashboard',
  },
  {
    name: 'Referral Management',
    icon: 'FaUserFriends',
    link: '/admin/referral-management',
    opened: false,
    active: false,
    tabLink: '/admin/referral-management',
    items: [],
  },
  {
    name: 'Search Log',
    icon: 'FaSearch',
    link: '/admin/search-log',
    items: [],
    opened: false,
    active: false,
    tabLink: '/admin/search-log',
  },
  {
    name: 'User Management',
    icon: 'FaUsers',
    link: '/admin/user-management',
    items: [],
    opened: false,
    active: false,
    tabLink: '/admin/user-management',
  },

  {
    name: 'Transactions',
    icon: 'FaExchangeAlt',
    link: '/admin/transactions',
    items: [],
    opened: false,
    active: false,
    tabLink: '/admin/transactions',
  },
  {
    name: 'Credit Amount',
    icon: 'FaCoins',
    link: '/admin/credit-management',
    items: [],
    opened: false,
    active: false,
    tabLink: '/admin/credit-management',
  },
  {
    name: 'User Statistics',
    icon: 'FaChartBar',
    link: '/admin/user-statistics',
    items: [],
    opened: false,
    active: false,
    tabLink: '/admin/user-statistics',
  },

  {
    name: 'Categories',
    icon: 'FaListAlt',
    link: '/admin/categories',
    items: [],
    opened: false,
    active: false,
    tabLink: '/admin/categories',
  },
  {
    name: 'Tags',
    icon: 'FaTag',
    link: '/admin/tags',
    items: [],
    opened: false,
    active: false,
    tabLink: '/admin/tags',
  },
  {
    name: 'Featured Categories',
    icon: 'FaStar',
    link: '/admin/featured-categories',
    items: [],
    opened: false,
    active: false,
    tabLink: '/admin/featured-categories',
  },

  {
    name: 'Order Management',
    icon: 'FaShoppingCart',
    link: '/admin/order-management',
    items: [],
    opened: false,
    active: false,
    tabLink: '/admin/order-management',
  },
  {
    name: 'Cross-Border Orders',
    icon: 'FaGlobe',
    link: '/admin/cross-border-orders',
    items: [],
    opened: false,
    active: false,
    tabLink: '/admin/cross-border-orders',
  },
  {
    name: 'Warehouse Management',
    icon: 'FaWarehouse',
    link: '/admin/warehouse-management',
    items: [],
    opened: false,
    active: false,
    tabLink: '/admin/warehouse-management',
  },
  {
    name: 'Ticket Management',
    icon: 'FaTicketAlt',
    link: '/admin/ticket-management',
    items: [],
    opened: false,
    active: false,
    tabLink: '/admin/ticket-management',
  },
  {
    name: 'Failed Orders',
    icon: 'FaBan',
    link: '/admin/failed-orders',
    items: [],
    opened: false,
    active: false,
    tabLink: '/admin/failed-orders',
  },

  {
    name: 'Subscription',
    icon: 'FaLayerGroup',
    link: '',
    opened: false,
    active: false,
    tabLink: '/admin/subscription/list',
    items: [
      {
        name: 'Add Subscription',
        link: '/admin/subscription/add',
      },
      {
        name: 'Subscription List',
        link: '/admin/subscription/list',
      },
    ],
  },
  {
    name: 'Products',
    icon: 'FaBox',
    link: '',
    opened: false,
    active: false,
    tabLink: '/admin/products/list',
    items: [
      {
        name: 'Add Products',
        link: '/admin/products/add',
      },
      {
        name: 'Product List',
        link: '/admin/products/list',
      },
      {
        name: 'Product Drafts',
        link: '/admin/product-drafts',
      },
    ],
  },

  {
    name: 'Membership Manage',
    icon: 'FaIdBadge',
    link: '/admin/membership-management',
    opened: false,
    active: false,
    tabLink: '/admin/membership-management',
    items: [],
  },
  {
    name: 'Global Product Search',
    icon: 'FaIdBadge',
    link: '/admin/alibaba-product',
    opened: false,
    active: false,
    tabLink: '/admin/alibaba-product',
    items: [],
  },
  {
    name: 'SKU Upload',
    icon: 'FaUpload',
    link: '/admin/sku-upload',
    opened: false,
    active: false,
    tabLink: '/admin/sku-upload',
    items: [],
  },
  {
    name: 'Pricing Algorithms',
    icon: 'FaDollarSign',
    link: '/admin/pricing-algorithms',
    opened: false,
    active: false,
    tabLink: '/admin/pricing-algorithms',
    items: [],
  },
  {
    name: 'Logistics',
    icon: 'FaTruck',
    link: '/admin/logistics',
    opened: false,
    active: false,
    tabLink: '/admin/logistics',
    items: [],
  },
  {
    name: 'Category Approval',
    icon: 'FaCheckCircle',
    link: '/admin/category-approval',
    opened: false,
    active: false,
    tabLink: '/admin/category-approval',
    items: [],
  },
  {
    name: 'Inquiries',
    icon: 'FaEnvelopeOpenText',
    link: '/admin/inquiries',
    items: [],
    opened: false,
    active: false,
    tabLink: '/admin/inquiries',
  },
  {
    name: 'Internal Users',
    icon: 'FaUserCog',
    link: '/admin/internal-users',
    opened: false,
    active: false,
    tabLink: '/admin/internal-users',
    items: [],
  },
  {
    name: 'Supplier Data Info',
    icon: 'FaStore',
    link: '/admin/supplier-data-info',
    opened: false,
    active: false,
    tabLink: '/admin/supplier-data-info',
    items: [],
  },
  {
    name: 'Cron Logs',
    icon: 'FaClock',
    link: '/admin/cron-logs',
    opened: false,
    active: false,
    tabLink: '/admin/cron-logs',
    items: [],
  },
  {
    name: 'Cron Management',
    icon: 'FaCogs',
    link: '/admin/cron-management',
    opened: false,
    active: false,
    tabLink: '/admin/cron-management',
    items: [],
  },
  {
    name: 'Role Management',
    icon: 'FaUserShield',
    link: '/admin/roles',
    opened: false,
    active: false,
    tabLink: '/admin/roles',
    items: [],
  },
  {
    name: 'AI Management',
    icon: 'FaRobot',
    link: '/admin/ai-management',
    opened: false,
    active: false,
    tabLink: '/admin/ai-management',
    items: [],
  },
  {
    name: 'Restricted Words',
    icon: 'FaBan',
    link: '/admin/restricted-words',
    opened: false,
    active: false,
    tabLink: '/admin/restricted-words',
    items: [],
  }
];

export const marketPlaces = [
  { name: 'Amazon' },
  { name: '⁠Flipkart' },
  { name: 'Meesho' },
  { name: '⁠India Mart' },
  { name: '⁠First Cry' },
  { name: '⁠Myntra' },
  { name: '⁠Nykaa' },
  { name: '⁠Ajio' },
  { name: '⁠Tata Cliq' },
  { name: '⁠Udaan' },
];

export const socialMedia = [{ name: 'Facebook' }, { name: '⁠Instagram' }, { name: 'Whatsapp' }];

export const ownWebsite = [{ name: 'Shopify' }, { name: '⁠Wordpress' }, { name: '⁠Opencart' }];

export const categories = [
  { name: 'Home Improvement & Kitchen' },
  { name: 'Lawn & Garden' },
  { name: 'Electronics - PC' },
  { name: 'Electronics - Accessories and Devices' },
  { name: 'Electronics - Mobile Phones and Accessories' },
  { name: 'BISS - Industrial' },
  { name: 'BISS - Lab Supplies' },
  { name: 'BISS - Mechanical Fasteners' },
  { name: 'Shoes and Handbags' },
  { name: 'Luggage' },
  { name: 'Jewellery' },
  { name: 'Watches' },
  { name: 'Beauty' },
  { name: 'Baby Product' },
  { name: 'Toys' },
  { name: 'Sports' },
  { name: 'Office Products' },
  { name: 'Musical Instruments' },
  { name: 'Video Games - Console' },
  { name: 'Gift Card' },
  { name: 'Shopify' },
  { name: 'Automotive' },
  { name: 'Pet Products' },
  { name: 'Personal Care Appliances' },
  { name: 'BISS - Professional Health Care' },
];

export const formatDate = date => {
  // this check, because by default moment.js give current date instead of throwing error.
  return date ? moment(date).format('Do MMM YYYY, h:mm a') : '-';
};

export const formatDateOnly = date => {
  return moment(date).format('DD/MM/YYYY');
};

export const jsonToCsv = (jsonData, keys, csvContent) => {
  // Extracting keys
  const keysVal = keys;
  // Writing CSV headers
  let csvContentVal = csvContent + '\n';

  // Writing CSV data
  for (let item of jsonData) {
    const values = keysVal.map(key => item[key]);
    csvContentVal += values.join(',') + '\n';
  }
  return csvContentVal;
};

export function downloadCsv(csvContent, fileName) {
  // Create a Blob object
  const blob = new Blob([csvContent], { type: 'text/csv' });

  // Create a download URL
  const url = window.URL.createObjectURL(blob);

  // Create a link element
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);

  // Append the link to the body
  document.body.appendChild(link);

  // Click the link to trigger download
  link.click();

  // Cleanup
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export const userApiTokenExpired = (status, navigate) => {
  if (status === 402) {
    navigate('/login');
  }
};

export const getRmbPriceToInr = price => price * PRICE_LOGIC.CHINA_CONVERSION_RATE;

export const reverseCalculateAP = (costPrice, markupPercentage) => {
  const markupFactor = 1 + markupPercentage / 100;
  const AP_INR = costPrice / markupFactor;
  const AP_RMB = AP_INR / PRICE_LOGIC.CHINA_CONVERSION_RATE; // convert INR → RMB
  return AP_RMB;
};

export const calculateAP = (rmbPrice, markupPercentage) => {
  const ap = rmbPrice;
  const AP_INR = Number(ap || 0) * PRICE_LOGIC.CHINA_CONVERSION_RATE; // AP in INR = AP (RMB) × RMB to INR rate
  const MP = AP_INR * markupPercentage; // Markup Price = AP × markup %
  const CP = AP_INR + MP; // Cost Price = AP + MP
  return CP;
};

/**
 * Shuffles an array randomly using Fisher-Yates algorithm
 * @param {Array} array - Array to shuffle
 * @returns {Array} - Shuffled array
 */
export const shuffleArray = array => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

/**
 * Randomly selects n items from an array
 * @param {Array} array - Array to select from
 * @param {number} count - Number of items to select
 * @returns {Array} - Array of randomly selected items
 */
export const getRandomItems = (array, count) => {
  const shuffled = shuffleArray(array);
  return shuffled.slice(0, count);
};

// Fetch local shipping cost separately
export const fetchLocalShippingCost = async (productOfferId, skuIdsNquantities = [], message = null) => {
  try {
    const result = await ProductsApiService.getLocalShippingCost(productOfferId, skuIdsNquantities);
    if (result.success) {
      return result.shippingCost;
    } else {
      if (message) message.showToast(`Failed to fetch local shipping cost: ${result.message}`, ToastTypes.ERROR);
      // console.info(`Failed to fetch local shipping cost: API Response `, result);
      return null;
    }
  } catch (error) {
    if (message) message.showToast(`Failed to fetch local shipping cost: ${error.message}`, ToastTypes.ERROR);
    // console.info(`Failed to fetch local shipping cost: API Error `, error);
    return null;
  }
};

export async function productPricingAlgorithm(product, productSaleInfo, productShippingInfo, productSkuInfos, skipApiCall = false) {
  const isDropshipping = product.minOrderQuantity === 1;

  let minRangePrice = 0;
  let maxRangePrice = 0;
  let rangedStartQuantity = 1;

  let minVariantPrice = Infinity;
  let maxVariantPrice = 0;

  let minVariantDeadWeight = Infinity;
  let maxVariantDeadWeight = 0;

  let minVariantVolumetricWeight = Infinity;
  let maxVariantVolumetricWeight = 0;

  let variantSkuId;
  let variantDeadWeight;
  let variantVolumetricWeight;

  const requiredDetails = {
    priceRangeList: productSaleInfo?.priceRangeList,
    variantShippingDetails: productShippingInfo?.skuShippingDetails,
    productShippingInfo: productShippingInfo,
    variants: productSkuInfos || [],
  };
  // removed fallback dimesions n wight given by api, keep only seller given dimensions n weight.
  // if(requiredDetails.productShippingInfo){
  //    const { weight, width, height, length } = requiredDetails.productShippingInfo || {};
  //   variantDeadWeight = minVariantDeadWeight = weight ?? minVariantDeadWeight;
  //   variantVolumetricWeight = minVariantVolumetricWeight = length && width && height ? length * width * height : 0;
  //    maxVariantDeadWeight = weight ?? maxVariantDeadWeight;
  //     maxVariantVolumetricWeight = length && width && height ? length * width * height : 0;
  // }

  if (requiredDetails.priceRangeList?.length > 0) {
    requiredDetails.priceRangeList.sort((a, b) => parseFloat(a.startQuantity) - parseFloat(b.startQuantity));
    rangedStartQuantity = parseInt(requiredDetails.priceRangeList[0].startQuantity);
    minRangePrice = parseFloat(requiredDetails.priceRangeList[0].price);
    maxRangePrice = parseFloat(requiredDetails.priceRangeList[requiredDetails.priceRangeList.length - 1].price);
  }

  const minPriceVariant = requiredDetails.variants.reduce((acc, v) => {
    const accPrice =
      parseFloat(
        isDropshipping ? acc?.fenxiaoPriceInfo?.onePiecePrice || acc?.fenxiaoPriceInfo?.offerPrice || acc?.consignPrice || acc?.price || 0 : acc?.consignPrice || acc?.price || 0
      ) || Infinity;
    const vPrice = parseFloat(
      isDropshipping ? v?.fenxiaoPriceInfo?.onePiecePrice || v?.fenxiaoPriceInfo?.offerPrice || v?.consignPrice || v?.price || 0 : v?.consignPrice || v?.price || 0
    );
    return accPrice > vPrice ? v : acc;
  }, {});

  // ALWAYS use weight and dimensions from detailed_info.productShippingInfo.skuShippingDetails by matching skuId
  // For minimum AP_RMB calculation, find the variant with minimum price and get its weight/dimensions from skuShippingDetails
  if (requiredDetails?.variantShippingDetails?.length > 0) {
    // First, find the minimum price variant
    const minPriceVariantSkuId = minPriceVariant?.skuId;
    
    if (minPriceVariant && minPriceVariantSkuId) {
      const skuVariantPrice = parseFloat(
        isDropshipping
          ? minPriceVariant?.fenxiaoPriceInfo?.onePiecePrice || minPriceVariant?.fenxiaoPriceInfo?.offerPrice || minPriceVariant?.consignPrice || minPriceVariant?.price || 0
          : minPriceVariant?.consignPrice || minPriceVariant?.price || 0
      );
      
      // Use unified chargeable weight calculation function
      const defaultWeight = PRICE_LOGIC.DEFAULT_DW || 0.5;
      const volumeFactor = PRICE_LOGIC.VOLUME_FACTOR || 5000;
      const chargeableWeight = calculateChargeableWeight(
        requiredDetails.variantShippingDetails,
        minPriceVariantSkuId,
        defaultWeight,
        volumeFactor
      );

      minVariantPrice = skuVariantPrice;
      variantDeadWeight = chargeableWeight;
      
      // Calculate volumetric weight for vw calculation (in cm³, will be divided by volumeFactor later)
      const minPriceShippingDetail = requiredDetails.variantShippingDetails.find(shp => 
        String(shp.skuId) === String(minPriceVariantSkuId) || shp.skuId === minPriceVariantSkuId
      );
      const currLength = minPriceShippingDetail?.length || 0;
      const currWidth = minPriceShippingDetail?.width || 0;
      const currHeight = minPriceShippingDetail?.height || 0;
      variantVolumetricWeight = (currLength && currWidth && currHeight) 
        ? currLength * currWidth * currHeight 
        : defaultWeight * volumeFactor; // Convert default weight to volume for consistency
      variantSkuId = minPriceVariant.skuId;

      // Also track max price variant for completeness
      for (const shp of requiredDetails.variantShippingDetails) {
        const skuVariant = requiredDetails.variants.find(v => 
          String(v.skuId) === String(shp.skuId) || v.skuId === shp.skuId
        );
        if (skuVariant) {
          const skuVariantPrice = parseFloat(
            isDropshipping
              ? skuVariant?.fenxiaoPriceInfo?.onePiecePrice || skuVariant?.fenxiaoPriceInfo?.offerPrice || skuVariant?.consignPrice || skuVariant?.price || 0
              : skuVariant?.consignPrice || skuVariant?.price || 0
          );
          if (skuVariantPrice > maxVariantPrice) {
            maxVariantPrice = skuVariantPrice;
          }
        }
      }
    } else {
      // Fallback to original logic if shipping detail not found
      for (const shp of requiredDetails?.variantShippingDetails) {
        const currWeight = shp.weight;
        const currHeight = shp.height;
        const currWidth = shp.width;
        const currLength = shp.length;

        const skuVariant = minPriceVariant.skuId === parseInt(shp.skuId) ? minPriceVariant : null;
        if (skuVariant) {
          const skuVariantPrice = parseFloat(
            isDropshipping
              ? skuVariant?.fenxiaoPriceInfo?.onePiecePrice || skuVariant?.fenxiaoPriceInfo?.offerPrice || skuVariant?.consignPrice || skuVariant?.price || 0
              : skuVariant?.consignPrice || skuVariant?.price || 0
          );
          const maxPriceAvailable = skuVariantPrice > maxVariantPrice;
          if (maxPriceAvailable) {
            maxVariantPrice = skuVariantPrice;
            variantDeadWeight = currWeight ? currWeight : PRICE_LOGIC.DEFAULT_DW;
            variantVolumetricWeight = currLength && currWidth && currHeight ? currLength * currWidth * currHeight : PRICE_LOGIC.DEFAULT_DW;
          }
          const minPriceAvailable = skuVariantPrice <= minVariantPrice;
          if (minPriceAvailable) {
            minVariantPrice = skuVariantPrice;
            variantDeadWeight = currWeight;
            if (currLength && currWidth && currHeight) {
              const currentVolumentricWeight = currLength * currWidth * currHeight;
              variantVolumetricWeight = currentVolumentricWeight;
            }
          }

          variantSkuId = skuVariant.skuId;
        }
      }
    }
  }
  else if (requiredDetails?.variantShippingDetails?.length === 0 && requiredDetails.variants?.length > 0) {
    requiredDetails.variants.forEach(variant => {
      const skuVariantPrice = parseFloat(
        isDropshipping
          ? variant?.fenxiaoPriceInfo?.onePiecePrice || variant?.fenxiaoPriceInfo?.offerPrice || variant?.consignPrice || variant?.price || 0
          : variant?.consignPrice || variant?.price || 0
      );
      if (minVariantPrice >= skuVariantPrice) {
        minVariantPrice = skuVariantPrice;
        minVariantDeadWeight = variantDeadWeight = PRICE_LOGIC.DEFAULT_DW;
      }
      if (maxVariantPrice < skuVariantPrice) {
        maxVariantPrice = skuVariantPrice;
        maxVariantDeadWeight = variantVolumetricWeight = PRICE_LOGIC.DEFAULT_DW;
      }
    });
  }

  if (minVariantDeadWeight === Infinity) minVariantDeadWeight = 0;
  if (minVariantVolumetricWeight === Infinity) minVariantVolumetricWeight = 0;
  if (minVariantPrice === Infinity) minVariantPrice = 0;

  const isMinMaxRange = minVariantPrice !== maxVariantPrice;
  const calculationData = {
    ap: minVariantPrice,
    ls: 0,
    hsn: false,
    hsnTaxPercent: PRICE_LOGIC.HSNTaxPercent,
    dw: variantDeadWeight || minVariantDeadWeight || maxVariantDeadWeight || PRICE_LOGIC.DEFAULT_DW,
    vw: (variantVolumetricWeight || minVariantVolumetricWeight || maxVariantVolumetricWeight || PRICE_LOGIC.DEFAULT_DW) / PRICE_LOGIC.VOLUME_FACTOR,
    sku: String(product.offerId), // offerId is typeof number in api response.
  };
  
  // COMMENTED: Freight API call - now using algorithm's local_shipping_rmb instead
  // let localShipping = 0;
  // localShipping = await fetchLocalShippingCost(product.offerId, [{ skuId: variantSkuId || product.offerId, quantity: 1 }]);
  // calculationData.ls = localShipping;
  
  // LS will be calculated from algorithm's local_shipping_rmb field
  calculationData.ls = 0;
  
  if (!(isDropshipping || isMinMaxRange)) {
    // WholeSale - ranged Price.
    calculationData.ap = minRangePrice;
  }

  // If skipApiCall is true, just return the calculation data without hitting the API
  // This allows batching multiple products into a single API call
  if (skipApiCall) {
    return { product, calculationData };
  }

  const pricingAlgorithm = await ProductsApiService.calculatePricingAlgorithm(calculationData);
  if (pricingAlgorithm) {
    product.priceInfo.finalPrice = pricingAlgorithm.data.breakdown.FBP;
    product.finalPrice = pricingAlgorithm.data.breakdown.FBP;
  }

  return { product, calculationData };
}

/**
 * Unified chargeable weight calculation function
 * 
 * Always uses weight and dimensions from detailed_info.productShippingInfo.skuShippingDetails
 * by matching skuId. This function is used for Search List and must be fully aligned with PDP logic.
 * 
 * @param skuShippingDetails - Array of shipping details from productShippingInfo.skuShippingDetails
 * @param skuId - The SKU ID to match (same SKU used for minimum AP_RMB calculation)
 * @param defaultWeight - Default fallback weight in kg (default: 0.5)
 * @param volumeFactor - Volume factor for dimensional weight calculation (default: 5000)
 * @returns Chargeable weight in kg (number)
 * 
 * Rules:
 * 1. If both W and V are available → Take max(W, V)
 * 2. If W is available but dimensions are missing/zero → Assume V = 0.5 → Take max(W, 0.5)
 * 3. If both W and dimensions are missing or zero → Chargeable weight = 0.5
 * 4. If W is missing but dimensions exist → Assume W = 0.5 → Take max(V, 0.5)
 * 
 * @example
 * const shippingDetails = [
 *   { skuId: "5783927183954", weight: 0.15, length: 0, width: 0, height: 0 }
 * ];
 * const chargeableWeight = calculateChargeableWeight(shippingDetails, "5783927183954");
 * // Returns: 0.5 (because weight is 0.15 but dimensions are 0, so max(0.15, 0.5) = 0.5)
 */
export function calculateChargeableWeight(
  skuShippingDetails: Array<{
    skuId: string | number;
    weight?: number;
    length?: number;
    width?: number;
    height?: number;
  }> | null | undefined,
  skuId: string | number | null | undefined,
  defaultWeight: number = 0.5,
  volumeFactor: number = 5000
): number {
  // Validate inputs
  if (!skuShippingDetails || !Array.isArray(skuShippingDetails) || skuShippingDetails.length === 0) {
    return defaultWeight;
  }

  if (skuId === null || skuId === undefined) {
    return defaultWeight;
  }

  // Find matching shipping detail by skuId (supports both string and number matching)
  const shippingDetail = skuShippingDetails.find(detail => 
    String(detail.skuId) === String(skuId) || detail.skuId === skuId
  );

  if (!shippingDetail) {
    return defaultWeight;
  }

  // Extract weight and dimensions, treating 0, null, or undefined as missing
  const weight = shippingDetail.weight && shippingDetail.weight > 0 ? shippingDetail.weight : 0;
  const length = shippingDetail.length && shippingDetail.length > 0 ? shippingDetail.length : 0;
  const width = shippingDetail.width && shippingDetail.width > 0 ? shippingDetail.width : 0;
  const height = shippingDetail.height && shippingDetail.height > 0 ? shippingDetail.height : 0;

  // Check availability
  const hasWeight = weight > 0;
  const hasDimensions = length > 0 && width > 0 && height > 0;

  // Calculate dimensional weight if dimensions are available
  const dimensionalWeight = hasDimensions ? (length * width * height) / volumeFactor : 0;

  // Apply chargeable weight rules
  let chargeableWeight: number;

  if (hasWeight && hasDimensions) {
    // Rule 1: Both W and V are available → Take max(W, V)
    chargeableWeight = Math.max(weight, dimensionalWeight);
  } else if (hasWeight && !hasDimensions) {
    // Rule 2: W is available but dimensions are missing/zero → Assume V = 0.5 → Take max(W, 0.5)
    chargeableWeight = Math.max(weight, defaultWeight);
  } else if (!hasWeight && hasDimensions) {
    // Rule 4: W is missing but dimensions exist → Assume W = 0.5 → Take max(V, 0.5)
    chargeableWeight = Math.max(dimensionalWeight, defaultWeight);
  } else {
    // Rule 3: Both W and dimensions are missing or zero → Chargeable weight = 0.5
    chargeableWeight = defaultWeight;
  }

  // Ensure we return a valid number (safety check)
  return typeof chargeableWeight === 'number' && !isNaN(chargeableWeight) && isFinite(chargeableWeight)
    ? chargeableWeight
    : defaultWeight;
}

const xTimesLarger = 5;
export const isVolumetricWeigthExtraLarge = (dw: number, vw: number): boolean => {
  const largerDW = dw * xTimesLarger;
  // const closestMinNumberWithZero = Math.pow(10, Math.floor(Math.log10(largerDW)));
  // const DW_Buffer_closestMaxNumberWithZero = (Math.floor(largerDW / closestMinNumberWithZero) + 1) * closestMinNumberWithZero;
  // if (vw > DW_Buffer_closestMaxNumberWithZero) return true;
  if (vw > largerDW) return true;
  return false;
};
